import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; 

import {
  HomeImageContainer
  , HomeContainer, HomeImage, HomeLoginContainer, FlexBox, LoginHeader, InputField,
  InputBox, LoginButton, EmptyBox, LoginButtonContainer,BackToLogin
} from './styled';
import { Header } from '../../components/header/internals'
import Image from '../../assets/homeimage.svg'



export const ForgetPassword = (props:any) => {
  const [formFields, setFormFields] = useState({  emailId: ''})
  const [errorField, setErrorField] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<any>(false);
  const navigate = useNavigate();
   
  const errorStyle = { 
    borderColor: 'red', 
  };
  const showToastMessage = (message: any) => {
    apiClient.showErrorMessage(message);
  };
  const showSuccessMessage = (message: any) => {
    apiClient.showSuccessMessage(message);
  };
  
  const handleOnChange = (event: any, identifier: any) => {
    let fields: any = { ...formFields };
    fields[identifier] = event.target.value;
    setErrorField(null);
    setFormFields(fields);

  };

  const handleSubmit = () => {
    
    
    if (formFields.emailId == null || formFields.emailId == undefined || formFields.emailId == '') {
      showToastMessage('Email Id is required');
      setErrorField('emailId')
      return;
    }
    if (!apiClient.validateEmail(formFields.emailId)) {
      showToastMessage('Please Enter Valid email');
      setErrorField('emailId')
      return;
    }
    
    setIsLoading(true);
    
    let payload={ 
      emailId:  formFields.emailId, 
      username:  formFields.emailId, 
      password:"",
      usertype:"business"
    }
    apiClient.post('app-users/forgotpassword', payload,null).then((response: any) => {
      setIsLoading(false); 
      if(response.result)
      {
        showSuccessMessage(response.message);
        navigate('/home');    
      }
      else
      {
        showToastMessage(response.message);
      }
    }).catch((err) => {
      setIsLoading(false);
    })
  }

  return (
    <HomeContainer>
      <Header />
      <FlexBox >
        <HomeImageContainer>
          <HomeImage src={Image} />
        </HomeImageContainer>

        <HomeLoginContainer>
          <LoginHeader>
            Forgot Password
          </LoginHeader>
           <InputField style={errorField=='emailId'?errorStyle:{}} >
            <InputBox type="text" placeholder='Enter Email ID' value={formFields.emailId} onChange={(event) => handleOnChange(event, 'emailId')}  ></InputBox>
          </InputField>
           <BackToLogin>
            <Link style={{
              color: '#4285F4', textDecoration: 'none',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '20px',
              paddingLeft: '5px',
              cursor: 'pointer'
            }} to={'/home'}>Back To Login</Link>   </BackToLogin>
          
          
          <EmptyBox />
          <LoginButtonContainer>
            <LoginButton disabled={isLoading} onClick={handleSubmit} >Continue</LoginButton>
          </LoginButtonContainer>
        </HomeLoginContainer>

      </FlexBox>

    </HomeContainer>
  );
};
